import {
  Alert,
  Button,
  EmailInput,
  Form,
  FormItem,
  FormOnFinish,
  Validation,
  useForm,
} from "@clarkinc/zest-design-system";
import React, { useState } from "react";
import { submitEmail } from "./requests";
import EmailValidationRegex from "~/common/EmailValidationRegex";

type FormState = {
  emailaddress: string;
};

const validateFormat: Validation<string> = (value): void => {
  if (!EmailValidationRegex.test(value)) {
    throw new Error("Invalid email format.");
  }
};

const BlogFooterEmail = () => {
  const form = useForm<FormState>();

  const [formState, setFormState] = useState<"idle" | "error" | "success">(
    "idle"
  );

  const handleSubmit: FormOnFinish<FormState> = async (state) => {
    const { emailaddress } = state;
    const result = await submitEmail(emailaddress.value);

    if (result.isError) {
      setFormState("error");
      return;
    }

    setFormState("success");
  };

  return (
    <div className="max-w-xs !flex !flex-col w-full md:flex-row md:gap-x-[26px] lg:gap-x-1 xl:gap-x-[26px] md:items-center lg:items-baseline xl:items-center pb-2">
      {formState === "success" && (
        <Alert
          theme="wss"
          isOpen
          variant="success"
          closable
          onClose={() => setFormState("idle")}
          wrapperProps={{
            className: "m-auto border-solid text-xl leading-5 md:w-full",
          }}
          closeButtonProps={{ className: "bg-transparent" }}
        >
          <p className="m-0 text-gray-800 text-sm font-bold">
            You&apos;re in! Be on the lookout for incoming deals and coupons
          </p>
        </Alert>
      )}
      <div
        className={`wss md:flex w-full ${
          formState === "error" ? "flex-col" : ""
        }`}
      >
        {formState !== "success" && (
          <Form
            name="mailing-list"
            form={form}
            noValidate
            onFinish={handleSubmit}
            className="!flex w-full h-full"
          >
            <FormItem
              defaultValue=""
              name="emailaddress"
              validate={validateFormat}
            >
              <EmailInput
                aria-label="Enter your email address"
                data-testid="blog-footer-email-input"
                inputSize="large"
                hideLabel
                label="Enter your email to get latest deals and more."
                errorMessage="Please enter a valid email address."
                errorProps={{ className: "whitespace-nowrap" }}
                id="emailaddress"
                name="emailaddress"
                wrapperProps={{ className: "mt-0 w-full" }}
                className="pr-[85px] mt-0"
              />
            </FormItem>
            <Button
              aria-label="Join our mailing list"
              className="border-l-0 focus:border-l-0 focus:rounded-l-none px-3.5 rounded-l-none whitespace-nowrap mb-1 ml-[-85px]"
              size="large"
              type="submit"
              variant="blue"
            >
              Sign Up
            </Button>
          </Form>
        )}
        {formState === "error" && (
          <Alert
            theme="wss"
            isOpen
            variant="error"
            closable
            onClose={() => setFormState("idle")}
            wrapperProps={{
              className:
                "mx-auto border-solid text-xl leading-5 md:w-full mt-1.5",
            }}
            closeButtonProps={{ className: "bg-transparent" }}
          >
            <p className="m-0 text-gray-800 text-sm font-bold">
              An error occurred. Please try again.
            </p>
          </Alert>
        )}
      </div>
    </div>
  );
};

export default BlogFooterEmail;
